import React, { useState } from "react";
import { Button, Modal, Form, Input, message } from "antd";
import { apiRequests } from "src/shared/api/api";

function AvitoButtonModal({ query, websocket }) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      const response = await apiRequests.avito.connect({
        api_key: values.api_key,
        api_secret: values.api_secret,
        redirect_uri: values.redirect_uri || undefined,
        channel_name: values.channel_name || undefined,
      });

      message.success("Данные сохранены! Откройте ссылку для авторизации.");
      setIsModalVisible(false);
      form.resetFields();
      
      if (response.data?.authorization_url) {
        window.open(response.data.authorization_url, '_blank');
      }
      
    } catch (error) {
      console.error("Ошибка при подключении Avito:", error);
      if (error.response?.data?.detail) {
        message.error(`Ошибка: ${error.response.data.detail}`);
      } else {
        message.error("Не удалось подключить канал Avito. Проверьте правильность данных.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button onClick={showModal}>Подключить</Button>
      <Modal
        title="Подключение канала Avito"
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        confirmLoading={loading}
        okText="Подключить"
        cancelText="Отмена"
        width={600}
      >
        <Form
          form={form}
          layout="vertical"
          requiredMark={false}
        >
          <Form.Item
            label="API Key (Client ID)"
            name="api_key"
            rules={[
              { required: true, message: "Пожалуйста, введите API Key" },
            ]}
          >
            <Input placeholder="Введите API Key" />
          </Form.Item>

          <Form.Item
            label="API Secret (Client Secret)"
            name="api_secret"
            rules={[
              { required: true, message: "Пожалуйста, введите API Secret" },
            ]}
          >
            <Input.Password placeholder="Введите API Secret" />
          </Form.Item>

          <Form.Item
            label="Redirect URI"
            name="redirect_uri"
          >
            <Input placeholder="https://app.tablecrm.com/api/v1/avito/oauth/callback" />
          </Form.Item>

          <Form.Item
            label="Название канала"
            name="channel_name"
            tooltip="Введите название для этого канала Avito. Если не указано, будет использовано название по умолчанию."
          >
            <Input placeholder="Например: Avito Москва" />
          </Form.Item>

          <div style={{ marginTop: 16, padding: 12, backgroundColor: "#f0f0f0", borderRadius: 4 }}>
            <p style={{ margin: 0, fontSize: 12 }}>
              <strong>Где найти эти данные:</strong>
            </p>
            <p style={{ margin: "8px 0 0 0", fontSize: 12 }}>
              1. Перейдите в{" "}
              <a href="https://developers.avito.ru/applications" target="_blank" rel="noopener noreferrer">
                личный кабинет разработчика Avito
              </a>
            </p>
            <p style={{ margin: "4px 0 0 0", fontSize: 12 }}>
              2. Создайте новое приложение или выберите существующее
            </p>
            <p style={{ margin: "4px 0 0 0", fontSize: 12 }}>
              3. Скопируйте Client ID (это API Key) и Client Secret (это API Secret)
            </p>
          </div>
        </Form>
      </Modal>
    </>
  );
}

export default AvitoButtonModal;


